export default {
  fontFamily: [
    'Lato',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"'
  ].join(','),
  orderSummaryFontFamily: ['"Segoe UI"', 'Lato'].join(',')
};
